import ClubStaticPages from './ClubStaticPages';

export default ClubStaticPages;
